export const setDesktopWindowTheme = async (_mode?: string, _variant?: string) => {
  // Stub for non-desktop environment
}